/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Faq_4_QuestionInputs */

const en_svc_agents_faq_4_question = /** @type {(inputs: Svc_Agents_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you build agents in n8n or in code?`)
};

const lv_svc_agents_faq_4_question = /** @type {(inputs: Svc_Agents_Faq_4_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai aģentus veidojat n8n vai kodā?`)
};

/**
* | output |
* | --- |
* | "Do you build agents in n8n or in code?" |
*
* @param {Svc_Agents_Faq_4_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_faq_4_question = /** @type {((inputs?: Svc_Agents_Faq_4_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Faq_4_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_faq_4_question(inputs)
	return en_svc_agents_faq_4_question(inputs)
});